import React, { useEffect, useState } from "react";
import HeaderComponent from "../../Components/Header/header";
import "./resumen.css";
import FiltersComponent from "../../Components/Filters/filters";
import ProductsSearchbarComponent from "../../Components/Products-Searchbar/products-searchbar";
import ProductsListComponent from "../../Components/Products-list/products-list";
import useProductStore from "../../Stores/productStore";
import useShoppingKartStore from "../../Stores/shoppingKartStore";
import {
  Button,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  TextField,
} from "@mui/material";
import AddressModalComponent from "../../Components/Address-Modal/address-modal";
import Paypal from "../../Components/PaypalButtons/paypal";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function ResumenViewComponent() {
  const productList = useShoppingKartStore((state) => state.shoppingKart);
  const [total, setTotal] = useState(0);
  const [selectedAddress, setSelectedAddress] = useState(undefined);
  const [addressToEdit, setAddressToEdit] = useState(undefined);
  const [addressList, setAddressList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const history = useHistory();

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const bgStyle = {
    backgroundPosition: "center",
    backgroundSize: "cover",
  };

  useEffect(() => {
    let userId = localStorage.getItem("userId");
    if (userId) {
      fetch("https://grupo-serdan-back-iplv-dev.fl0.io/api/addresses/" + userId)
        .then((data) => data.json())
        .then((res) => {
          setAddressList([...res]);
        });
    } else {
      history.push("/iniciar-sesion");
    }
  }, []);

  useEffect(() => {
    let tmpTotal = 0;
    productList.forEach((el) => {
      tmpTotal += el.price * el.qty;
    });
    setTotal(tmpTotal);
  }, [productList]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const gotoLastStep = () => {
    setActiveStep(2);
  };

  const addToAddresses = (address) => {
    setAddressList([...addressList, address]);
  };

  return (
    <section>
      <HeaderComponent />
      <div className="resumen-page">
        <AddressModalComponent
          isOpen={openModal}
          closeModal={handleCloseModal}
          address={addressToEdit}
          addToAddresses={addToAddresses}
        />
        <div className="card-container">
          <div style={{ flex: "3 1" }}>
            <Stepper activeStep={activeStep} alternativeLabel>
              <Step>
                <StepLabel>Elegir dirección</StepLabel>
              </Step>
              <Step>
                <StepLabel>Envío y pago</StepLabel>
              </Step>
              <Step>
                <StepLabel>Pedido completado</StepLabel>
              </Step>
            </Stepper>
            <div className="direccion-card">
              <div style={{ display: activeStep === 0 ? "block" : "none" }}>
                <h2>Dirección de envío</h2>
                <div className="direccion-section-container">
                  <div className="direccion-list-container">
                    {addressList.length === 0 && (
                      <p>Aún no tienes ninguna dirección</p>
                    )}
                    {addressList.map((address) => (
                      <div
                        key={address.id}
                        onClick={() => setSelectedAddress({ ...address })}
                        className="direccion-info-card"
                        style={
                          selectedAddress?.id === address.id
                            ? { border: "1px solid blue" }
                            : {}
                        }
                      >
                        <span>
                          {address.clientName} {address.clientLastName}
                        </span>
                        <br />
                        <span>
                          {address.streetName} {address.houseNumber}
                        </span>
                        <br />
                        <span>
                          {address.neighbourhood} {address.postalCode}
                        </span>
                        <br />
                        <span>
                          {address.city}, {address.state}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className="direccion-buttons-container">
                    <Button
                      onClick={handleOpenModal}
                      fullWidth
                      style={{ marginBottom: "5px" }}
                      variant="contained"
                    >
                      Agregar dirección nueva
                    </Button>
                    <Button
                      disabled={!selectedAddress}
                      onClick={() => {
                        setAddressToEdit({ ...selectedAddress });
                        handleOpenModal();
                      }}
                      fullWidth
                      variant="contained"
                    >
                      Editar dirección
                    </Button>
                  </div>
                  <div style={{ flex: "0 0 100%" }}>
                    <Button
                      onClick={() => setActiveStep(1)}
                      disabled={!selectedAddress}
                      style={{ marginTop: "5px" }}
                      variant="contained"
                    >
                      Confirmar Dirección
                    </Button>
                  </div>
                </div>
              </div>
              <div style={{ display: activeStep === 1 ? "block" : "none" }}>
                <div
                  style={{
                    margin: "5px",
                    border: "1px solid black",
                    borderRadius: "8px",
                    padding: "5px",
                    textAlign: "center",
                  }}
                >
                  <h2>Dirección de envío:</h2>
                  <span>
                    {selectedAddress?.clientName}{" "}
                    {selectedAddress?.clientLastName} -{" "}
                    {selectedAddress?.clientCellphone}
                  </span>
                  <br />
                  <span>
                    {selectedAddress?.streetName} {selectedAddress?.houseNumber}
                  </span>
                  <br />
                  <span>
                    {selectedAddress?.neighbourhood}{" "}
                    {selectedAddress?.postalCode}
                  </span>
                  <br />
                  <span>
                    {selectedAddress?.city}, {selectedAddress?.state}
                  </span>
                </div>
                <Paypal gotoLastStep={gotoLastStep} />
                <Button
                  onClick={() => setActiveStep(0)}
                  disabled={!selectedAddress}
                  style={{ marginTop: "5px" }}
                  variant="contained"
                >
                  {"<"} Cambiar dirección
                </Button>
              </div>
              <div style={{ display: activeStep === 2 ? "block" : "none" }}>
                <h1>Gracias por tu pedido</h1> <br />
                <p>Tu pedido ha sido recibido y ahora está siendo procesado</p>
              </div>
            </div>
          </div>
          <div className="carrito-card border-grey">
            <h2 style={{ fontSize: "16px" }}>Carrito de compras</h2>
            {productList.map((el) => (
              <div className="order-item mb-2">
                <div className="product-text flex-row border-top-grey">
                  <div className="product-text-big-section">
                    <p style={{ fontSize: "14px" }} className="product-header">
                      {el.name}
                    </p>
                  </div>
                  <div className="product-text-small-section">
                    <span
                      style={{
                        fontSize: "12px",
                        border: "1px solid black",
                        padding: "3px 6px",
                      }}
                    >
                      {el.qty}
                    </span>
                  </div>
                  <div className="product-text-small-section">
                    <span className="product-price">
                      {formatter.format(Number(el.price * el.qty))}
                    </span>
                  </div>
                </div>
              </div>
            ))}
            <div className="full-width total-container">
              <div className="total-amount-container">
                <span>Subtotal</span>
                <span className="total-container-price">
                  {formatter.format(Number(total))}
                </span>
              </div>
              <div className="total-amount-container">
                <span>Costo de envío</span>
                <span className="total-container-price">
                  {formatter.format(Number(199))}
                </span>
              </div>
              <div className="total-amount-container total-ammount-container">
                <span>Total</span>
                <span className="total-container-price total-ammount-price">
                  {formatter.format(Number(total + 199))}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ResumenViewComponent;
